import { Component, inject, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from './core/loading/loading.component';
import { ThemeService } from './core/theme/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule, LoadingComponent],
    standalone: true
})
export class AppComponent {
  title = 'MAPFOREST';

  // Injetado só para aplicar o tema salvo na inicialização (o botão de alternar entra no incremento 7).
  private readonly theme = inject(ThemeService);



}
